/* ==========================================================================
   SYGMA — COMPONENTES DE FICHA Y COLECCIÓN
   Se carga SÓLO en las plantillas de producto y colección: no tiene sentido
   que quien aterriza en la portada pague la galería y las facetas.
   Se apoya en window.SYGMA, que define sygma.js, y por eso va después.
   ========================================================================== */
(function () {
  'use strict';

  var strings = (window.SYGMA && window.SYGMA.strings) || {};
  function on(el, type, fn, opts) { el.addEventListener(type, fn, opts || false); }

  class SygmaGallery extends HTMLElement {
    connectedCallback() {
      this.mainImage = this.querySelector('[data-sygma-gallery-main] img');
      this.thumbs = Array.from(this.querySelectorAll('[data-sygma-gallery-src]'));
      this.dialog = this.querySelector('[data-sygma-lightbox]');
      this.dialogImage = this.querySelector('[data-sygma-lightbox-image]');
      if (!this.mainImage) return;

      this.thumbs.forEach((thumb) => {
        on(thumb, 'click', (event) => {
          event.preventDefault();
          this.select(thumb);
        });
      });

      // La imagen principal abre el lightbox. Es un <button> creado aquí y no
      // en Liquid: sin JS no haría nada, y un botón muerto es peor que ninguno.
      if (this.dialog && typeof this.dialog.showModal === 'function') {
        var zoom = document.createElement('button');
        zoom.type = 'button';
        zoom.className = 'sygma-gallery__zoom';
        zoom.setAttribute('aria-label', (strings.zoom || 'Ampliar'));
        on(zoom, 'click', () => this.open());
        this.querySelector('[data-sygma-gallery-main]').appendChild(zoom);

        var close = this.querySelector('[data-sygma-lightbox-close]');
        if (close) on(close, 'click', () => this.dialog.close());
        // Clic en el backdrop: el <dialog> ocupa toda la pantalla, así que un
        // clic cuyo destino sea el propio dialog cae fuera de la imagen.
        on(this.dialog, 'click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
      }
    }

    select(thumb) {
      var src = thumb.dataset.sygmaGallerySrc;
      this.mainImage.removeAttribute('srcset');
      this.mainImage.src = src;
      this.mainImage.alt = thumb.dataset.sygmaGalleryAlt || '';
      this.thumbs.forEach((t) => t.removeAttribute('aria-current'));
      thumb.setAttribute('aria-current', 'true');
      this.current = thumb;
    }

    open() {
      if (!this.dialog || !this.dialogImage) return;
      this.dialogImage.src = this.current
        ? this.current.dataset.sygmaGallerySrc
        : this.mainImage.currentSrc || this.mainImage.src;
      this.dialogImage.alt = this.mainImage.alt || '';
      this.dialog.showModal();
    }
  }

  class SygmaStickyCta extends HTMLElement {
    connectedCallback() {
      var form = document.querySelector('sygma-product-form');
      if (!form || !('IntersectionObserver' in window)) return;
      var self = this;

      // La barra sólo aparece cuando el formulario ha quedado por ENCIMA del
      // viewport. «No se ve» no basta: eso también es cierto antes de llegar a
      // él, y la barra saldría sobre el héroe ofreciendo comprar algo que el
      // usuario todavía no ha visto.
      //
      // La geometría se lee EN VIVO y no del `entry`: un IntersectionObserver
      // sólo dispara al cruzar el umbral, y su boundingClientRect es la foto
      // de ese instante. Con un scroll rápido esa foto llega desfasada y la
      // barra se queda en el estado equivocado.
      function sync() {
        var rect = form.getBoundingClientRect();
        self.hidden = rect.bottom > 0;
      }

      new IntersectionObserver(sync, { threshold: 0 }).observe(form);
      // El observer no dispara si al cargar ya estamos por debajo (enlace con
      // ancla, vuelta atrás del navegador), así que se sincroniza una vez.
      sync();
      on(window, 'scroll', sync, { passive: true });
    }
  }

  class SygmaFacets extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      var submit = this.querySelector('[data-sygma-facets-submit]');
      if (submit) submit.hidden = true;

      // Un cambio de casilla o de select reenvía; un rango numérico espera a
      // que el usuario termine de teclear, o cada dígito dispararía una carga.
      on(this.form, 'change', (event) => {
        if (event.target.type === 'number') return;
        this.apply();
      });
      on(this.form, 'input', this.debounce((event) => {
        if (event.target.type === 'number') this.apply();
      }, 600));
    }

    debounce(fn, wait) {
      var timer;
      return function () {
        var args = arguments, self = this;
        window.clearTimeout(timer);
        timer = window.setTimeout(function () { fn.apply(self, args); }, wait);
      };
    }

    apply() {
      // Sin campos vacíos en la URL: un ?filter.v.price.gte= suelto ensucia el
      // enlace que el usuario puede compartir y confunde a la analítica.
      var params = new URLSearchParams();
      new FormData(this.form).forEach(function (value, key) {
        if (String(value).trim() !== '') params.append(key, value);
      });
      var query = params.toString();
      window.location.search = query ? '?' + query : '';
    }
  }

  var registry = {
    'sygma-gallery': SygmaGallery,
    'sygma-sticky-cta': SygmaStickyCta,
    'sygma-facets': SygmaFacets
  };
  Object.keys(registry).forEach(function (tag) {
    if (!customElements.get(tag)) customElements.define(tag, registry[tag]);
  });
})();
